import { useListingTotal } from "./hooks/usePublicListings";
import { getIcon } from "./icons";
import { TRUST_FEATURES } from "./data/landingData";

/** Feature strip under the hero. The listing total is real (API) and shown only when available. */
const TrustStrip = () => {
  const { status, data: total } = useListingTotal();

  return (
    <section className="lp-trust" aria-label="Why All Home Desire">
      <div className="container">
        <ul className="lp-trust__list list-unstyled mb-0">
          {status === "success" && total ? (
            <li className="lp-trust__item lp-trust__item--stat">
              <strong className="lp-trust__value">{total.toLocaleString("en-IN")}</strong>
              <span className="lp-trust__text">Properties listed</span>
            </li>
          ) : null}
          {TRUST_FEATURES.map(({ icon, title, text }) => {
            const Icon = getIcon(icon);
            return (
              <li key={title} className="lp-trust__item">
                <span className="lp-icon-box lp-icon-box--sm" aria-hidden="true">
                  <Icon />
                </span>
                <span>
                  <strong className="lp-trust__title">{title}</strong>
                  <span className="lp-trust__text">{text}</span>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default TrustStrip;
